var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cmp-versions-container',  _vm.getItem('activeTab') == 'compare-versions'? '' : 'hide']},[_c('CompareVersionsHeader'),_c('div',{class:['compare-box']},[_c('div',{class:['compare-body']},[_c('CompareTOC'),_c('CompareSummary')],1)]),(this.getItem('compareVersionsError')!='')?_c('CompareVersionsFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }